import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { theme, ifProp } from 'styled-tools'
import { color, rgba, rem, media, mediaMaxWidth } from '../../utils/styles'

const innerColor = color('white')
const outerColor = color('light')
const bgColor = ifProp('current', outerColor, innerColor)
const arrowOverColor = ifProp('current', rgba('light', 0), rgba('white', 0))
const fontWeight = ifProp('current', theme('fontWeights.bold'), theme('fontWeights.regular'))
const innerArrowSize = rem(17)
const outerArrowSize = rem(22)
const mobileMaxWidth = mediaMaxWidth('tablet')

export const StepBase = styled.li`
  flex: 1;
  position: relative;
  counter-increment: stepper;
  border: ${rem(4)} solid ${outerColor};
  border-radius: ${rem(10)};
  background-color: ${bgColor};

  &:not(:last-child) {
    margin-bottom: ${rem(22)};

    ${media('tablet')`
      margin-right: ${rem(22)};
      margin-bottom: 0;
    `}
  }

  &:not(:last-child)::before,
  &::after{
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;

    ${media('tablet')`
      left: 100%;
      top: 50%;
    `}
  }

  &:not(:last-child)::after {
    border-color: ${arrowOverColor};
    border-width: ${innerArrowSize};

    @media (max-width: ${mobileMaxWidth}) {
      border-top-color: ${bgColor};
      margin-left: -${innerArrowSize};
      margin-top: ${rem(-1)};
    }

    ${media('tablet')`
      border-left-color: ${bgColor};
      margin-top: -${innerArrowSize};
      margin-left: ${rem(-1)};
    `}
  }

  &:not(:last-child)::before {
    border-color: ${rgba('light', 0)};
    border-width: ${outerArrowSize};

    @media (max-width: ${mobileMaxWidth}) {
      border-top-color: ${outerColor};
      margin-left: -${outerArrowSize};
    }

    ${media('tablet')`
      border-left-color: ${outerColor};
      margin-top: -${outerArrowSize};
    `}
  }
`

export const StepContent = styled.a`
  display: flex;
  font-weight: ${fontWeight};
  padding: ${rem(12)} ${rem(16)};
  height: 100%;
  text-decoration: none;

  ${media('tablet')`
    padding: ${rem(16)} ${rem(42)} ${rem(16)} ${rem(16)};
  `}
  ${media('tablet')`
    flex-direction: column;
  `}

  &::before {
    content: counter(stepper);
    font-weight: ${theme('fontWeights.bold')};
    margin-right: ${rem(8)};

    ${media('tablet')`
      margin-bottom: ${rem(8)};
    `}
  }
`

function Step({
  current,
  children,
  disabled,
  as,
  ...props
}) {
  return (
    <StepBase current={current}>
      <StepContent
        {...props}
        current={current}
        as={disabled ? 'span' : as}
      >
        {children}
      </StepContent>
    </StepBase>
  )
}

Step.propTypes = {
  current: PropTypes.bool,
  children: PropTypes.node
}

export default Step
